import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "DiagnosticsAndSupport" */ './lazyIndex')
);

// Delay loaded components for in-app support
export let lazyHandleSupportPaneEvents = new LazyAction(lazyModule, m => m.handleSupportPaneEvents);
export let lazyInitializeSupportOnBoot = new LazyAction(lazyModule, m => m.initializeSupportOnBoot);
export let lazyRenderSupportPane = new LazyAction(lazyModule, m => m.renderSupportPane);
export let lazyOnSupportPaneOpen = new LazyAction(lazyModule, m => m.onSupportPaneOpen);
export let lazyOnSupportPaneClose = new LazyAction(lazyModule, m => m.onSupportPaneClose);

// Delay loaded components for feedback support
export let lazyInitializeFeedbackOnBoot = new LazyAction(
    lazyModule,
    m => m.initializeFeedbackOnBoot
);
export let lazyRenderFeedbackPane = new LazyAction(lazyModule, m => m.renderFeedbackPane);
export let lazyOnFeedbackPaneOpen = new LazyAction(lazyModule, m => m.onFeedbackPaneOpen);
export let lazyOnFeedbackPaneClose = new LazyAction(lazyModule, m => m.onFeedbackPaneClose);

// Non-lazy util functions
export { isSupportEnabled } from './utils/utils';
export { isDiagFeedbackEnabled } from './utils/utils';
